import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK, SystemRole} from '../../../Constants'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {
    createOrUpdateHospital,
    getListHospitals,
    getPageHospitals,
    getSectionListHospital,
} from '../HospitalEndPoint'

export const usePageHospitals = (
    requestorId,
    userRole,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {hospitalKeys} = QueryKeyManager(QueryKeyTypes.hospital, requestorId)

    return useQuery({
        queryKey: hospitalKeys.page({
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPageHospitals(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                filterRequest,
            ),
        enabled: !!requestorId && userRole === SystemRole.ADMIN && !!enabled,
    })
}

export const useListHospitals = (
    requestorId,
    simple,
    filterRequest,
    enabled = true,
) => {
    const {hospitalKeys} = QueryKeyManager(QueryKeyTypes.hospital, requestorId)

    return useQuery({
        queryKey: hospitalKeys.list({
            simple,
            filterRequest,
        }),
        queryFn: () => getListHospitals(requestorId, simple, filterRequest),
        enabled: !!requestorId && !!enabled,
    })
}

export const useSectionListHospitals = (
    requestorId,
    filterRequest,
    enabled = true,
) => {
    const {hospitalKeys} = QueryKeyManager(QueryKeyTypes.hospital, requestorId)

    return useQuery({
        queryKey: hospitalKeys.sectionList({
            filterRequest,
        }),
        queryFn: () => getSectionListHospital(requestorId, filterRequest),
        enabled: !!requestorId && !!enabled,
    })
}

export const useHospitalCRUD = (type, requestorId) => {
    const {hospitalKeys} = QueryKeyManager(QueryKeyTypes.hospital, requestorId)
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateHospital(requestorId, data)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Hospital Update Successfully !!',
                    )
                }
            }
        },
    })
}
